import { createBrowserRouter, Navigate } from "react-router-dom";
import { Me } from "~/layouts";
import Orders from "~/routes/orders";
import Home from "~/routes/home";
import NotFound from "~/routes/not-found";
import Permalink from "~/routes/permalink";

const router = createBrowserRouter([
    // {
    //     // @dependency: permalink - this url is coupled with backend
    //     path: "/approve/:id",
    //     element: <Permalink />,
    // },
    {
        path: "/me",
        element: <Me />,
        children: [
            {
                path: "orders",
                element: <Orders />,
            },
        ],
    },
    {
        path: "*",
        element: <Navigate to="/me/orders" replace />,
    },
    // {
    //     path: "*",
    //     element: <Permalink />, // @TODO: temp
    // },
    // {
    //     path: "*",
    //     element: <NotFound />,
    // },
]);

export default router;
